import { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api, { formatApiErrorDetail } from "@/lib/api";

export function HipaaAckBanner() {
  const [me, setMe] = useState(null);
  const [open, setOpen] = useState(false);
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/compliance/me").then((r) => setMe(r.data)).catch(() => {}); }, []);

  if (!me || !me.is_staff || me.acked) return null;

  const ack = async () => {
    setBusy(true);
    try {
      await api.post("/compliance/ack");
      setMe({ ...me, acked: true });
      setOpen(false);
      toast.success("Thanks — your acknowledgement is recorded");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <div data-testid="hipaa-ack-banner" className="mx-6 mt-4 flex flex-wrap items-center gap-3 rounded-xl border border-sky-200 bg-sky-50 px-5 py-3">
        <ShieldCheck className="h-5 w-5 text-primary flex-shrink-0" />
        <div className="flex-1 min-w-[200px] text-sm text-slate-800"><b>HIPAA training acknowledgement needed.</b> Please confirm you've completed privacy & security training before working with health records.</div>
        <button onClick={() => setOpen(true)} data-testid="hipaa-ack-open" className="h-9 rounded-lg bg-primary px-4 text-sm font-semibold text-white">Read & acknowledge</button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="hipaa-ack-dialog">
          <DialogHeader>
            <DialogTitle className="font-display flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" /> HIPAA privacy & security acknowledgement</DialogTitle>
            <DialogDescription>Training cycle {me.version}. This acknowledgement is recorded in the compliance log with today's date.</DialogDescription>
          </DialogHeader>
          <p className="rounded-lg bg-slate-50 border border-slate-200 p-4 text-sm leading-relaxed text-slate-700" data-testid="hipaa-ack-text">{me.text}</p>
          <label className="flex items-start gap-2 text-sm text-slate-800">
            <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} data-testid="hipaa-ack-checkbox" className="mt-0.5 h-4 w-4 rounded border-slate-300" />
            I have read and agree to the statement above.
          </label>
          <div className="flex justify-end gap-2 pt-1">
            <button onClick={() => setOpen(false)} className="h-10 rounded-lg border border-slate-200 px-4 text-sm font-medium text-slate-700">Later</button>
            <button onClick={ack} disabled={!agree || busy} data-testid="hipaa-ack-submit" className="h-10 rounded-lg bg-primary px-4 text-sm font-semibold text-white disabled:opacity-60 inline-flex items-center gap-2">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} I acknowledge
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
